import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs';
import { CommonService } from './common.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  accessToken = '';
  companyId = '';
  constructor(private router: Router, private commonService: CommonService) { }
  canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.commonService.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    } else {
      return true;
    }

  }
}

@Injectable()
export class NonLoggedInState implements CanActivate {
  accessToken = '';
  companyId = '';
  constructor(private router: Router, private commonService: CommonService) { }
  canActivate (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.commonService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}



